import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getReservationHistoryRequest = async (
  token,
  { getReservationHistoryData }
) => {
  const url =
    apiURl +
    "reservation/GetAllReservationsByDate?organizationId=" +
    getReservationHistoryData.organizationId +
    "&StartDate=" +
    getReservationHistoryData.StartDate +
    "&EndDate=" +
    getReservationHistoryData.EndDate;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getReservationHistoryRequest };
